import { useEffect, type MutableRefObject } from 'react';

/**
 * Point `ref` at `value` after each render in which `value` changed (or `when` became true). For a ref that
 * other code also writes ahead of state, such as a drag or zoom gesture that moves faster than renders:
 * unlike useLatest, it does not overwrite the ref on renders where nothing changed. With `when: false` the
 * ref keeps its last value (a panel's last expanded width while it is collapsed).
 *
 * When nothing else writes the ref, use useLatest instead.
 */
export function useMirror<T>(ref: MutableRefObject<T>, value: T, options: { when?: boolean } = {}): void {
    const when = options.when !== false;
    useEffect(() => {
        if (when) ref.current = value;
    }, [ref, value, when]);
}
